import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Logo from '@shared/components/Logo';
import ShopHeaderActions from '@shopDetails/components/ShopHeaderActions';
import ChevronLeft from '@pedidosya/web-fenix/icons/ChevronLeft';
import { onKeyDownFunction, onKeyUpFunction } from '@utils/a11y';

const Header = styled.header`
  align-items: center;
  justify-content: start;
  display: ${({ show }) => (show ? 'flex' : 'none')};
  height: 52px;
  background-color: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.elementLine};
  position: relative;
  z-index: ${({ theme }) => theme.constants.zIndex.mainHeader};
  flex-grow: 1;
`;

const HeaderLogo = styled(Logo)`
  width: 87px;
`;

const Actions = styled.div`
  margin-left: auto;
  cursor: 'pointer';
`;

const BackArrow = styled(ChevronLeft)`
  margin: 10px;
  cursor: pointer;
`;

function BrandHeader({ goBack, show, goTo, showActions }) {
  return (
    <Header show={show}>
      <BackArrow
        size="medium"
        tabIndex={0}
        onKeyUp={e =>
          onKeyUpFunction(e, () => goBack({ hasItemsChecked: false }))
        }
        onKeyDown={e =>
          onKeyDownFunction(e, () => goBack({ hasItemsChecked: false }))
        }
        role="button"
        aria-label="Volver"
        onClick={goBack}
      />
      <Link to={goTo}>
        <HeaderLogo />
      </Link>
      {showActions && (
        <Actions>
          <ShopHeaderActions showOnlinePaymentTooltip={false} />
        </Actions>
      )}
    </Header>
  );
}

BrandHeader.propTypes = {
  goBack: PropTypes.func.isRequired,
  show: PropTypes.bool,
  showActions: PropTypes.bool,
  goTo: PropTypes.string,
};

BrandHeader.defaultProps = {
  show: true,
  showActions: true,
};

export default BrandHeader;
